module.exports = __webpack_public_path__ + "img/bmm1.3ac21813.png";